import { Component, EventEmitter, HostListener, Input, OnInit, Output, Sanitizer } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { flatMap, forkJoin, Observable, of, map, mergeMap } from 'rxjs';
import { DaoService } from '../../../core/dao/dao.service';
import { ToastrService } from 'ngx-toastr';
import { ITileItem, TileItem } from '../../../core/models/tile-item.model';
import { AudioProcessorTask, AudioProcessorTaskBlock, IAudioProcessorTask, IAudioProcessorTaskBlock } from '../../../core/models/audio-processor-task.model';
import { IAudioPlugin } from '../../../core/models/plugin.model';
import { AsyncService } from '../../../core/async/async.service';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TaskModel } from '../task.model';

@Component({
  selector: 'app-task-selector',
  templateUrl: 'task.selector.component.html',
  styleUrls: ['task.selector.component.scss']
})
export class TaskSelectorComponent implements OnInit {

  plugins: IAudioPlugin[] = [];
  public loading: boolean = false;

  constructor(
    private dao: DaoService,
    private toastr: ToastrService,
    public taskModel: TaskModel,
    private async: AsyncService,
    private sanitizer: DomSanitizer,
    private router: Router) {

  }

  ngOnInit() {
  }

  createNewTask(plugin: IAudioPlugin) {
    this.taskModel.createNewTask(plugin);
  }

}
